// extracted by mini-css-extract-plugin
export default {"goBackButton":"go-back-button__x99cRDlk","close":"close__ehtcrLdZ","openInNewPage":"open-in-new-page__JV2XMbAG"};